/**
 * @license
 * Copyright The Closure Library Authors.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Provides the enum for the role of the CrossPageChannel.
 */

goog.provide('goog.net.xpc.CrossPageChannelRole');


/**
 * The role of the peer.
 * @enum {number}
 */
goog.net.xpc.CrossPageChannelRole = {
  OUTER: 0,
  INNER: 1,
};
